import { createContext } from 'react';

const seasonContext = createContext();

export default seasonContext;